<template>
    <div class="layout-container">
        <el-tabs type="border-card">
            <el-tab-pane label="已占用">
                <Bind />
            </el-tab-pane>
            <el-tab-pane label="已冻结">
                <Frozen />
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import Bind from './component/Bind'
import Frozen from "./component/Frozen";
export default {
    name: 'LayoutDemo',
    components: {
        Bind,
        Frozen
    }
}
</script>